namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmProfilVlastnostiObsah extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmProfilVlastnostiObsahReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmProfilVlastnostiObsahObj & GContent;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmProfilVlastnostiObsahObj());
            this.detailObj.createBase({
                contentName: "detailAdmProfilVlastnostiObsah",
                contentCaption: "jres:33000464",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmProfilVlastnostiObsah", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder();
            var rowPovinnost = this.findFormRows("row_priz_pov");
            rowPovinnost.gformrow("setLabel", "jres:29925144", "jres:33000606") //RC 33000606 : Vlastnost nebo v�echny vlastnosti struktury budou v tomto profilu povinn�
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmProfilVlastnostiObsahObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmProfilVlastnostiObsahReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return "{0} - {1}".format((this.data.ixs_pro_txt) ? this.data["ixs_pro_txt"] : "", (this.data.ixs_stv_txt) ? this.data["ixs_stv_txt"] : "")
        }

        setSxsDetail(): string {
            return "{0}#{1}#".format((this.data.ixs_pro) ? this.data.ixs_pro : "", (this.data.ixs_stv) ? this.data.ixs_stv : "");
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmProfilVlastnostiObsahSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmProfilVlastnostiObsah.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => { this.cnt.close() });
                    //this.showSuccessSave(close);
                    //this.reloadDataBase(false);
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            // Nen� nutno otev�rat detail
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmProfilVlastnostiObsah", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): JQueryPromise<Gordic.Data.View<Gordic.Data.UnpackRow<any>>> {
            return this.cnt.isl.AdmProfilVlastnostiObsah.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:33000552";
            return "{0} - {1} x {2}".format(this.options.contentCaption, (this.data.ixs_pro_txt) ? this.data.ixs_pro_txt : "", (this.data.ixs_stv_txt) ? this.data.ixs_stv_txt : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actNovaAdmStrutkuraVlastnosti: {
                    caption: "jres:33000554", //RC 33000554 : Nov� struktura vlastnost�
                    icon: "gi-plus",
                    run: (ev, ctx) => {
                        this.openNewStrukturaVlastnosti();
                    }
                },
                actNovaAdmVlastnost: {
                    caption: "jres:33000555", //RC 33000555 : Nov� vlastnost
                    icon: "gi-plus",
                    run: (ev, ctx) => {
                        this.openNewVlastnost();
                    }
                }
            }
            //return null;
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeSelectField("ixs_pro", Gordic.Prefabs.Select.ginspro(), {
                model: "model.ixs_pro=value.ixs_pro",
                dropdown: false,
            });
            this.MakeSelectField("ixs_stv", Gordic.Prefabs.Select.ginsstv(), {
                model: "model.ixs_stv=value.ixs_stv",
                dropdown: false,
                change: (ev, ctx) => {
                    if (this.editMode == true) {
                        if (ctx.value) {
                            if (!Array.isArray(ctx.value)) {
                                if (ctx.value.priz_vir == 1) {   // Priz vir znamen� vlastnost
                                    this.cnt.isl.AdmVlastnost.list({ filters: { ixs_vla: ctx.value.ixs_stv } }).getData().done((result) => {
                                        if (result.length > 0)
                                            this.cnt.findFields("priz_pov").gfield("setValue", result[0].priz_pov == 1)
                                        else
                                            this.cnt.findFields("priz_pov").gfield("setValue", false);
                                    })
                                } else {
                                    this.cnt.isl.AdmStrukturaVlastnosti.list({ filters: { ixs_stv: ctx.value.ixs_stv } }).getData().done((result) => {
                                        if (result.length > 0)
                                            this.cnt.findFields("priz_pov").gfield("setValue", result[0].priz_pov == 1)
                                        else
                                            this.cnt.findFields("priz_pov").gfield("setValue", false);
                                    })
                                }
                            }
                        }
                    }
                },
                buttons: [
                    {
                        type: "static",
                        icon: "gi-plus",
                        captionVisible: "never",
                        children: [
                            { action: this.cnt.actions.actNovaAdmStrutkuraVlastnosti },
                            { action: this.cnt.actions.actNovaAdmVlastnost }
                        ]
                    }
                ]
            });
            this.MakeField("kod_form");
            this.MakeField("k_v");
            this.MakeBoolField("priz_pov");
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        private openNewStrukturaVlastnosti() {
            $.content().dialogs.showModalWindow(["Gordic.Adm.WebControls.DetailAdmStrukturaVlastnosti", {
                returnValue: true,
                openModal: true
            }], {
                ID: "DetailAdmStrukturaVlastnosti",
                newRecord: true,
                ixs_stv: null
            }, {
                height: 800,
                width: 800
            }).on("close", (ev, obj) => {
                if (obj)
                   if (obj.ixs_stv)
                       this.cnt.findFields("ixs_stv").gfield("setValue", { ixs_stv: obj.ixs_stv }, false);
            })
        }

        private openNewVlastnost() {
            $.content().dialogs.showModalWindow(["Gordic.Adm.WebControls.DetailAdmVlastnost", {
                returnValue: true,
                openModal: true
            }], {
                ID: "DetailAdmVlastnost",
                newRecord: true,
                ixs_vla: null
            }, {
                height: 800,
                width: 800
            }).on("close", (ev, obj) => {
                if (obj)
                    if (obj.ixs_vla)
                        this.cnt.findFields("ixs_stv").gfield("setValue", { ixs_stv: obj.ixs_vla }, false)
            })
        }
    }
}